import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/cooking/cooking-classify-dev/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/cooking/cooking-classify-dev/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/cooking/cooking-classify-dev/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/cooking/cooking-classify-dev/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/cooking/cooking-classify-dev/detail',
    method: 'get',
    params: { id }
  })
}
